import { type FC } from 'react';
import { cn } from '@shared/cove-ui';

export interface DividerProps {
  className?: string;
}

const Divider: FC<DividerProps> = ({
    className = '',
    ...props
  }) => {
    return (
      <hr className={cn('mx-auto w-[calc(100%-50px)] sm:w-[calc(100%-100px)] max-w-screen-xxl', className)} {...props} />
    )
};

export default Divider;
